export class ChurnItemEntity {
  date!: string
  data_type!: 'users' | 'economics'
  rate!: number
  total!: number
  // Interval split of `total`, populated for the 'users' data type only.
  // The 'economics' (MRR) path has no yearly/monthly breakdown and sends 0.
  total_yearly?: number
  total_monthly?: number
}
